import { getKey, callOpenAICompat } from './shared';
import { t } from '../modules/i18n';

export async function callOpenAI(model, prompt, signal, opts) {
  const key = getKey("openai");
  if (!key) throw new Error(t("err.nokey", { provider: "OpenAI" }));
  return callOpenAICompat("OpenAI", "https://api.openai.com/v1/chat/completions", key, model, prompt, signal, opts);
}
